import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AdminNursinghomePage } from './admin-nursinghome';
import {DirectivesModule} from "../../directives/directives.module";
import {NgxDatatableModule} from "@swimlane/ngx-datatable";

@NgModule({
  declarations: [
    AdminNursinghomePage,
  ],
  imports: [
    IonicPageModule.forChild(AdminNursinghomePage),
    DirectivesModule,
    NgxDatatableModule,
  ],
})
export class AdminNursinghomePageModule {}



// WEBPACK FOOTER //
// ./src/pages/admin-nursinghome/admin-nursinghome.module.ts